var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircleOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0002 4.3335C14.0402 4.3335 4.3335 14.0402 4.3335 26.0002C4.3335 37.9602 14.0402 47.6668 26.0002 47.6668C37.9602 47.6668 47.6668 37.9602 47.6668 26.0002C47.6668 14.0402 37.9602 4.3335 26.0002 4.3335ZM26.0002 43.3335C16.4452 43.3335 8.66683 35.5552 8.66683 26.0002C8.66683 16.4452 16.4452 8.66683 26.0002 8.66683C35.5552 8.66683 43.3335 16.4452 43.3335 26.0002C43.3335 35.5552 35.5552 43.3335 26.0002 43.3335ZM21.6668 30.7018L35.9452 16.4235L39.0002 19.5002L21.6668 36.8335L13.0002 28.1668L16.0552 25.1118L21.6668 30.7018Z",
    fill: "#6C37CE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOutline);
export default __webpack_public_path__ + "static/media/checkCircleOutline.3994c4ef839ceb99a18de4bc957f25be.svg";
export { ForwardRef as ReactComponent };